import { ReactNode } from "react";

import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type DiscardedEntryProps = {
  timestamp: number;
  note: string | null;
  username: string | null;
  children: ReactNode;
};

const DiscardedEntry = ({ timestamp, note, username, children }: DiscardedEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Discarded</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Discarded}
      timestamp={timestamp}
      label={label}
      terminal
    >
      {note && <HistoryEntryNote>{note}</HistoryEntryNote>}
      {children}
    </HistoryEntryWrapper>
  );
};

export default DiscardedEntry;
